export default "__VITE_ASSET__d7832c4f__"